import { ConflictError } from '@ember-data/adapter/error'

/**
 * @param {ConflictError|Error|Object} error
 */
export function isConflictError(error: unknown) {
  return (
    error instanceof ConflictError ||
    String(
      (
        error as {
          response?: {
            status?: number
          }
        }
      )?.response?.status,
    ) === '409' ||
    String(
      (
        error as {
          status?: number
        }
      )?.status,
    ) === '409'
  )
}
